import { BaseContainerModel } from '../../../base-container.model';
import {
  bl_alg_cc_endpoint_hdr_RowInterface,
  bl_alg_cc_endpoint_hdr_RowClass,
} from '../../../../dbschema';

export class EndpointContainerModel extends BaseContainerModel {
  bl_alg_cc_endpoint_hdr: bl_alg_cc_endpoint_hdr_RowInterface =
    new bl_alg_cc_endpoint_hdr_RowClass();
}
